import { useVuelidate } from '@vuelidate/core'
import { reactive } from 'vue'

export default {
  install(app) {
    // Mixin para adicionar $v aos componentes que têm validations
    app.mixin({
      beforeCreate() {
        // Inicializar $v como um objeto stub com estrutura completa para evitar erros no template
        if (this.$options.validations) {
          // Criar estrutura stub baseada nas validações se possível
          const validations = typeof this.$options.validations === 'function' ? this.$options.validations.call(this) : this.$options.validations

          if (validations) {
            // Criar estrutura stub recursiva baseada nas validações
            const createStub = (validationObj) => {
              const stub = { $error: false }
              Object.keys(validationObj).forEach((key) => {
                if (typeof validationObj[key] === 'object' && validationObj[key] !== null) {
                  stub[key] = createStub(validationObj[key])
                } else {
                  stub[key] = { $error: false }
                }
              })
              return stub
            }

            this.$v = {
              ...createStub(validations),
              $error: false,
              $touch: () => {},
              $reset: () => {},
            }
          } else {
            this.$v = {
              $error: false,
              $touch: () => {},
              $reset: () => {},
            }
          }
        }
      },
      created() {
        // Se o componente já tem setup() e retorna v$, não usar o plugin
        // (componentes que usam setup() diretamente não precisam do plugin)
        if (this.$options.setup) {
          return
        }

        if (this.$options.validations) {
          try {
            const validations = typeof this.$options.validations === 'function' ? this.$options.validations.call(this) : this.$options.validations

            if (!validations) {
              // Manter estrutura básica se não houver validações
              this.$v = {
                $error: false,
                $touch: () => {},
                $reset: () => {},
              }
              return
            }

            // Criar estado reativo a partir do data usando reactive
            const state = reactive({ ...this.$data })

            // Sincronizar mudanças do data com o state reativo
            Object.keys(this.$data).forEach((key) => {
              if (typeof this.$data[key] === 'object' && this.$data[key] !== null && !Array.isArray(this.$data[key])) {
                state[key] = reactive({ ...this.$data[key] })
              } else {
                state[key] = this.$data[key]
              }
            })

            // Inicializar Vuelidate
            this.$v = useVuelidate(validations, state)

            // Sincronizar mudanças do state do Vuelidate de volta para o data
            this.$watch(
              () => state,
              (newState) => {
                Object.keys(newState).forEach((key) => {
                  if (this.$data[key] !== newState[key]) {
                    this.$data[key] = newState[key]
                  }
                })
              },
              { deep: true },
            )
          } catch (error) {
            console.error('Error initializing Vuelidate:', error)
            // Manter estrutura básica em caso de erro
            this.$v = {
              $error: false,
              $touch: () => {},
              $reset: () => {},
            }
          }
        }
      },
    })
  },
}
